import {
	SortDirection,
	type MarriageSearchOptions,
	type MarriageSearchResults,
	type ObjectSchemaProperty,
} from "@/models"
import { provide, reactive } from "vue"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import BasicPage from "../BasicPage"
import {
	convertFromSendableColumns,
	convertFromSendableFilters,
	convertFromSendableSort,
	getRequiredObjectSchemaProperty,
} from "./SearchComponents/Helpers"
import MarriageClaimSearchContent from "./SearchComponents/MarriageClaimSearchContent"
import { EditingSearchState, EditingSearchStateInjectionKey } from "./state"

function defaultSort() {
	return {
		direction: SortDirection.Descending,
		by: getRequiredObjectSchemaProperty(["ClaimId"]),
	}
}
function defaultColumns() {
	return [
		getRequiredObjectSchemaProperty(["ClaimRef"]),
		getRequiredObjectSchemaProperty(["Status"]),
		getRequiredObjectSchemaProperty(["Details", "FirstName"]),
		getRequiredObjectSchemaProperty(["Details", "LastName"]),
		getRequiredObjectSchemaProperty(["HighestEarner"]),
		getRequiredObjectSchemaProperty(["DateCreated"]),
	]
}

const MarriageSearchInitializer: ReactiveComponent = () => {
	const initialResults = reactive<MarriageSearchResults>({
		MarriageClaims: [],
		TotalItems: 0,
		PageNumber: 1,
	})
	const initialColumns = reactive<ObjectSchemaProperty[]>(
		convertFromSendableColumns(localStorage.getItem("Columns")) ?? defaultColumns()
	)
	const initialSearchOptions = reactive<MarriageSearchOptions>({
		PageNumber: 1,
		PageSize: 15,
		Sort: convertFromSendableSort(localStorage.getItem("Sort")) ?? defaultSort(),
		Filters: convertFromSendableFilters(localStorage.getItem("Filters")) ?? [],
	})
	const state = new EditingSearchState(initialResults, initialColumns, initialSearchOptions)
	provide(EditingSearchStateInjectionKey, state)
	void state.executeSearch()

	return () => (
		<BasicPage title="Marriage Claim Search" plain>
			<MarriageClaimSearchContent />
		</BasicPage>
	)
}
export default defineComponent(MarriageSearchInitializer)
